import { render, staticRenderFns } from "./uploadAgain.vue?vue&type=template&id=0b59021a&"
import script from "./uploadAgain.vue?vue&type=script&lang=js&"
export * from "./uploadAgain.vue?vue&type=script&lang=js&"
import style0 from "./uploadAgain.vue?vue&type=style&index=0&id=0b59021a&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports